module.exports = __webpack_public_path__ + "media/images/products/at1/at1-1-400x400-db1a408d97b60de563aaf0d1dafa32e6.png";